// Tracks which product IDs get resolved via findProductByID/findByRoutePath/
// productsByItemID during a single SSR render, so main-server.js's
// context.rendered hook can prune every other product out of the state
// before it's serialized for client hydration (see
// store/index.js's pruneUnreferencedProducts action).
//
// The tracking Set lives as a non-enumerable property directly on the
// products module's state object, rather than in a module-scoped variable,
// because the SSR bundle's module cache (runInNewContext: 'once') persists
// across requests in the same worker - a plain module-level Set would leak
// tracked IDs between concurrent/sequential requests. Attaching to state
// and having main-server.js call reset() fresh at the start of every
// request keeps this correctly request-scoped regardless of that. Non-
// enumerable so JSON.stringify(context.state) (how ssrv2 serializes the
// hydration payload) skips it automatically - no explicit cleanup needed.
export function reset(state) {
  Object.defineProperty(state, '$accessedProductIds', {
    value: new Set(),
    enumerable: false,
    configurable: true,
    writable: false
  })
}

export function track(state, id) {
  if (state && state.$accessedProductIds && id !== undefined && id !== null) {
    state.$accessedProductIds.add(id)
  }
}

export function getTracked(state) {
  return (state && state.$accessedProductIds) || new Set()
}
